import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import Loader from "Component/Loader";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import defaultstateimg from "../../../../Assets/Svg/holidayEmpty.svg";
import headersList from "../../../../Constants/headersList";
import DefaultComp from "../../../../Component/DefaultComp/Defaultstatecomp";
import { instance } from "../../../../Actions/AxiosInstance";
import { ChangeLanguage } from "../../../../Actions/LanguageAction";
import { List, TDTypeConsts } from "../../business-configration/commons";
import "./index.css";

class OptionalHoliday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      holidayList: [],
      permissions: { editable: true, readonly: true },
      optionalheaders: [
        {
          key: "holidayname",
          name: "Optional Holiday’s Name",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "holidaydate",
          name: "Holiday’s Date",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_DATE,
          style: {},
        },
        {
          key: "isselected",
          name: (
            <FormattedMessage
              id="LbHolidaySelected"
              defaultMessage="Holiday Selected?"
            />
          ),
          type: TDTypeConsts.HOLIDAY_SELECTED,
          style: {},
        },
      ],
      mandatoryheaders: [
        {
          key: "holidayname",
          name: "Mandatory Holiday’s Name",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "holidaydate",
          name: "Holiday’s Date",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_DATE,
          style: {},
        },
      ],
      data: false,
    };
  }

  componentWillMount() {
    const [isTrue, permissions] = CheckActionPermission("holiday");
    if (isTrue) {
      this.setState({ permissions });
      this.props.ChangeLanguage("optionalholiday,navigation");
      this.getOptionalHolidayList();
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getOptionalHolidayList() {
    this.setState({ boolIsLoader: true });
    instance
      .post("leaves/getemployeeholiday/3")
      .then((result) => {
        let holidayList = [];
        result.data.result.length > 0
          ? (holidayList = result.data.result)
          : (holidayList = []);
        const mandatoryholidays =
          holidayList &&
          holidayList.filter((holiday) => holiday.ismandatory == true);
        const optionalholidays =
          holidayList &&
          holidayList.filter((holiday) => holiday.ismandatory == false);
        this.setState({
          holidayList,
          optionalholidays,
          mandatoryholidays,
          data: true,
          boolIsLoader: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
        this.setState({ boolIsLoader: false });
      });
  }

  onEdit = (item) => {
    if (item) {
      this.props.history.push(`./holiday/select_holiday`);
    }
  };

  _renderOptionalHolidayList = () => {
    const { optionalholidays = [] } = this.state;
    const migrateholiday = this.props.AuthenticationAction.login.migration.find(
      (x) => x.moduletypeid == 8,
    );
    return (
      <React.Fragment>
        <div>
          {migrateholiday && migrateholiday.isenable && (
            <div
              style={{
                float: "right",
                color: "#057cff",
                fontWeight: 400,
                marginBottom: 24,
                marginTop: -20,
                cursor: "pointer",
              }}
              onClick={() => {
                window.open(migrateholiday.oldurl);
              }}
            >
              View holiday in sumHR 2.0
            </div>
          )}
          <div>
            <List
              list={this.state.optionalholidays}
              headers={this.state.optionalheaders}
              headerIndex={0}
              noSort
              onCreate={
                optionalholidays.length !== 0 ? this.onEdit.bind(this) : null
              }
              createbuttonName="Select holidays"
              module="Optional Holiday"
              sortOrder="desc"
              permissions={this.state.permissions}
            />
          </div>
        </div>
        <div style={{ height: 50 }} />

        <List
          list={this.state.mandatoryholidays}
          headers={this.state.mandatoryheaders}
          headerIndex={0}
          noSort
          // onCreate={mandatoryholidays.length != 0 ? this.onEdit.bind(this): null}
          createbuttonName="Select optional holiday"
          module="Mandatory Holiday"
          sortOrder="desc"
          permissions={this.state.permissions}
        />
      </React.Fragment>
    );
  };

  render() {
    const { match } = this.props;
    const language = this.props.Language.optionalholiday;
    return (
      <div>
        <Helmet>
          <title>{headersList.Holiday.header}</title>
        </Helmet>
        <IntlProvider locale="en" messages={language}>
          {
          this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) 
          : this.state.boolIsLoader 
            ? (
              <Loader />
              )
            : (
            <main className="content-outer-wrapper">
              {this.state.data &&
              this.state.holidayList &&
              this.state.holidayList.length > 0 ? (
                <Grid container>
                  <Grid item xs={12} md={12} sm={12} className="device-wrapper">
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}`}
                        render={this._renderOptionalHolidayList}
                      />
                    </Switch>
                  </Grid>
                </Grid>
              ) : (
                <Grid container>
                  <Grid item xs={12} md={12} sm={12} className="position-rel">
                    <DefaultComp
                      //  text={this.getText()}
                      heading={
                        <FormattedMessage
                          id="conceptbucreate"
                          defaultMessage="There are no holidays assigned!"
                        />
                      }
                      subheading={
                        <FormattedMessage
                          id="#"
                          defaultMessage="Kindly wait till your holidays are assigned to view them."
                        />
                      }
                      // onCreate={this._onCreate}
                      imageSrc={defaultstateimg}
                      permissions={this.state.permissions}
                    />
                  </Grid>
                </Grid>
              )}
            </main>
          )}
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(OptionalHoliday));
